import { render } from "./AddVacationTemplateDetails.vue?vue&type=template&id=f535d5be"
import script from "./AddVacationTemplateDetails.vue?vue&type=script&lang=js"
export * from "./AddVacationTemplateDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__